(() => {
  const root = document.querySelector('.gj-halloween');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const page = root.dataset.page;
  const seed = [...(root.dataset.handle || location.pathname)].reduce((n, c) => n + c.charCodeAt(0), 0);
  const piece = (kind, place) => {
    const wrap = document.createElement('div');
    wrap.className = 'gj-hw-piece gj-hw-' + place;
    wrap.dataset.hwArt = kind;
    if (kind.startsWith('spider')) wrap.append(document.createElement('i'));
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    const symbol = document.getElementById('gj-hw-' + kind);
    svg.setAttribute('viewBox', symbol.getAttribute('viewBox'));
    svg.setAttribute('focusable','false');
    [...symbol.children].forEach(child => svg.append(child.cloneNode(true)));
    wrap.append(svg);
    return wrap;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('is-visible', entry.isIntersecting));
  }, {rootMargin:'0px',threshold:0}) : null;
  const mount = (selector, name, items) => {
    const host = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!host || host.querySelector(':scope > .gj-hw-scene--' + name)) return;
    if (getComputedStyle(host).position === 'static') host.classList.add('gj-hw-positioned');
    const scene = document.createElement('div');
    scene.className = 'gj-hw-scene gj-hw-scene--' + name;
    scene.setAttribute('aria-hidden','true');
    scene.dataset.hwScene = name;
    items.forEach(([kind,place]) => scene.append(piece(kind,place)));
    host.append(scene);
    if (observer) observer.observe(scene);
    else scene.classList.add('is-visible');
  };
  if (page === 'index') {
    mount('.gj-shape-explorer-shell','entrance',[['web','web-left'],['web-torn','web-right'],['spider','spider'],['bat','bat-a'],['moon','moon'],['pumpkin','pumpkin'],['candy','candy'],['ghost','ghost-small']]);
    mount('.gj-shape-explorer-shell','forms',[['web-drape','web-left'],['spider-long','spider'],['lollipop','candy-high']]);
    mount('#gammes','gammes',[['web-orb','web-left'],['skeleton-dance','skeleton'],['candy-round','candy-high']]);
    mount('#choisir-sa-gamme','guide',[['web-torn','web-right'],['cat','cat'],['candy-corn','candy'],['witch-flight','witch']]);
    mount('#tailles','tailles',[['web-drape','web-left'],['spider-round','spider'],['skull-hand','skull'],['lollipop','candy']]);
    mount('#recharges','recharges',[['web-sail','web-right'],['pumpkin-tall','pumpkin'],['witch-cauldron','witch'],['candy-round','candy']]);
    mount('#journal','journal',[['web-orb','web-left'],['witch-flight','witch'],['candy-corn','candy-high'],['spider-long','spider']]);
  } else if (page === 'list-collections') {
    mount('#MainContent','catalogue',[['web-torn','web-left'],['spider-round','spider'],['witch-flight','broom']]);
  } else if (page === 'collection' || page === 'search') {
    mount('#MainContent','catalogue',[['web-drape','web-right'],['spider','spider']]);
    mount('.collection-page__results','collection-background',[['web-sail','back-web'],['spider-long','back-spider'],['candy-round','back-candy'],['lollipop','back-lollipop'],['skull-hand','back-skull']]);
  } else if (page === 'product') {
    mount('#MainContent','product',[['web-orb','web-right'],['bat','bat-a'],['spider-long','spider']]);
  } else {
    mount('#MainContent','catalogue',[['web-torn','web-left'],['spider-round','spider']]);
  }
  const endings = [
    [['grave','grave'],['pumpkin-tall','pumpkin'],['candy-corn','candy-high']],
    [['skeleton','skeleton'],['cat','cat'],['candy-round','candy-high']],
    [['ghost','ghost-small'],['pumpkin','pumpkin'],['cat','cat']]
  ];
  mount('.site-footer','footer',endings[seed % endings.length]);
  window.addEventListener('pagehide', () => observer?.disconnect(), {once:true});
  window.addEventListener('pageshow', event => {
    if (event.persisted && observer) document.querySelectorAll('.gj-hw-scene').forEach(scene => observer.observe(scene));
  });
})();
